import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import cuid from 'cuid'
import renderRoutes from 'client/routes/renderRoutes'
import App from 'core/modules/App'
import AppStoreDashboardContainer from 'store/modules/AppStoreDashboardContainer'


const AppStoreContainer = (props) => {
  useEffect(() => {
    const users_id = localStorage.getItem('users_id')

    if (!users_id) {
      const randomUserId = cuid()
      localStorage.setItem('users_id', randomUserId)
    }
  }, [])

  return (
    <App>
      <AppStoreDashboardContainer {...props}>
        { renderRoutes({
          routes: props.route.routes,
          location: props.location,
        }) }
      </AppStoreDashboardContainer>
    </App>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

export default connect(mapStateToProps)(AppStoreContainer)
